import React, { ReactElement } from 'react';
import { useParams } from 'react-router-dom';

import { Dropdown } from 'ui/patterns';
import { Button } from 'ui/components';

import { useDeleteContacts } from 'hooks';

import * as Icon from 'assets/icons';

import { confirmAlert } from 'utils/confirm-alert';
import { TableContactOptionsType } from './contactListTypes';

export default function TableOptionsHeader(
  props: TableContactOptionsType,
): ReactElement {
  const contactId = props.row.original.Id;
  const params = useParams<{
    accountId: string;
  }>();
  const accountId = parseInt(params.accountId);
  const { mutate: deleteContact } = useDeleteContacts(contactId, accountId);

  const contactListOptions = [
    {
      value: 'Edit Contact',
      icon: <Icon.Edit title="Options" />,
      groupEnd: true,
      action: () => props.onEditPress && props.onEditPress(contactId),
    },
    {
      value: 'Delete Contact',
      icon: <Icon.Delete title="Options" />,
      action: () => handleDeleteContact(),
    },
  ];

  const handleDeleteContact = () => {
    confirmAlert({
      message: 'Are you sure you want to delete this contact?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            deleteContact({ contactId, accountId });
          },
          className: 'pr-btn-primary',
        },
        {
          label: 'No',
          onClick: () => {
            //
          },
        },
      ],
    });
  };

  const contactListDropdown = () => (
    <Button size="sm">
      <Icon.DotsVertical title="Options" />
    </Button>
  );

  return (
    <>
      <Dropdown
        trigger={contactListDropdown()}
        menuList={contactListOptions}
        position="left-top"
        className="dd-listitem-options"
      />
    </>
  );
}
